import { Popconfirm } from "antd";

const AntPopConfirm = Popconfirm;

export { AntPopConfirm as PopConfirm };
